import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import notification from '../../../services/notification';
import types from '../../types';

function* getFees() {
  try {
    const { status, data } = yield call(api.market.fees.getFees);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_FEES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_FEES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateFees({ payload }) {
  try {
    const { status, data } = yield call(api.market.fees.updateFees, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_FEES_SUCCESS, payload: data });
    yield put({
      type: types.GET_FEES_START,
      payload: { level_id: payload?.fees[0]?.level_id },
    });
  } catch (error) {
    yield put({ type: types.UPDATE_FEES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* fees() {
  yield all([
    takeLatest(types.GET_FEES_START, getFees),
    takeLatest(types.UPDATE_FEES_START, updateFees),
  ]);
}
